import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { WebPortalClient, Country } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../misc/api/WebPortalTokenClient";
import LoadingWithMessage from "../misc/components/LoadingWithMessage";

export const SupportContactDetails = () => {
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();
    const [countries, setCountries] = React.useState<Country[]>();
    const [contactEmail, setContactEmail] = React.useState<string>();

    React.useEffect(() => {
        const getData = async () => {
            const studyResult = await client.client.getStudy(study.id);
            setContactEmail(studyResult.vitalographContactEmail ?? "websupport@vitalograph.co.uk");
            const countryResult = await client.client.getStudyCountries(undefined, `studyId eq ${study.id}`);
            setCountries(countryResult.value);
        }

        getData();
    }, [client.client]);

    if (!countries)
        return <LoadingWithMessage message="Loading Support Contact Details..." />

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h2 className="text-primary">Support Contact Information</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <div className="row">
                                <p className="col-md-12">
                                    Vitalograph have provided for this study a help desk and will be able to assist with the setup and any technical questions about the Vitalograph equipment or Portal.
                                    They cannot help with any protocol-related questions, please instead contact your Clinical Research Associate (CRA).
                                </p>
                            </div>
                            <div className="row">
                                {countries.map(c => (
                                    <div key={c.id} className="col-md-6 col-sm-6">
                                        <div className="contact-box">
                                            <div className="col-md-8">
                                                <span style={{ fontSize: 200 + '%' }}>
                                                    <FontAwesomeIcon icon={faPhone} />&nbsp;
                                                    {c.tollFreeNumber ?? "No number available"}
                                                </span>
                                            </div>
                                            <div className="col-md-4 col-sm-6">
                                                Vitalograph Support Services Toll Free Number for <b>{c.name}</b>
                                            </div>

                                            <div className="clearfix"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="well">
                                        <p>
                                            To email the Vitalograph Project Management study team please use the following address:
                                        </p>
                                        <p><a style={{ fontSize: 200 + '%' }} href={`mailto:${contactEmail}`}>{contactEmail}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
